$(document).ready(function() {
    $(document).foundation();
    
    $('.table-sessies').click(function(){        
        var checkCount = $('.sessies-radio:checked').length;
        if(checkCount >= 3){
            //console.log(checkCount);    
            $('#gaverder').removeClass('no-active');
        }
    });

    $('.table-sessies .lees-meer').click(function(){
        var parent = $(this).closest('td');
        if($(parent).hasClass('is-active')){
            $(parent).removeClass('is-active');
        } else {
            $(parent).addClass('is-active');
        }
        $('.description', parent).slideToggle();
    });
    
    $("#terug").click(function(){
        $('#gaverder').addClass('no-active');
        $('.table-sessies').each(function(){
            $(this).find('input[type="radio"]').prop('checked', false);
        });
    });    
    
    $('input[name=paymentmethod]').change(function() {
        //console.log($(this).val());
        if($(this).val() == '01'){
            $('#betaalmethode-01').show();
            $('#betaalmethode-02').hide();
        }
        if($(this).val() == '02'){
            $('#betaalmethode-02').show();
            $('#betaalmethode-01').hide();
        }
    });
    
    $('.tooltip-link').each(function() {
         $(this).qtip({
            hide: 'mouseleave',
            position: {
                my: 'top right',
                at: 'bottom left',
                target: 'mouse',
                viewport: $('.sibedar'),
                adjust: {
                    mouse: false,
                    scroll: false
                }
            },
            style: 'qtip-dark',
            content: {
                text: $(this).next('.event-tooltip'),
                title: {
                    //button: true
                }
            } 
         });
    });

    /*applyChosenSelects();
    function applyChosenSelects(){
        $('.chosenselect').select2({
            language: {
                errorLoading: function () {
                    return 'De resultaten konden niet worden geladen.';
                },
                inputTooLong: function (args) {
                    var overChars = args.input.length - args.maximum;

                    var message = 'Gelieve ' + overChars + ' karakters te verwijderen';

                    return message;
                },
                inputTooShort: function (args) {
                    var remainingChars = args.minimum - args.input.length;

                    var message = 'Gelieve ' + remainingChars +
                        ' of meer karakters in te voeren';

                    return message;
                },
                loadingMore: function () {
                    return 'Meer resultaten laden…';
                },
                maximumSelected: function (args) {
                    var verb = args.maximum == 1 ? 'kan' : 'kunnen';
                    var message = 'Er ' + verb + ' maar ' + args.maximum + ' item';

                    if (args.maximum != 1) {
                        message += 's';
                    }
                    message += ' worden geselecteerd';

                    return message;
                },
                noResults: function () {
                    return 'Geen resultaten gevonden…';
                },
                searching: function () {
                    return 'Zoeken…';
                },
                removeAllItems: function () {
                    return 'Verwijder alle items';
                }

            },
            ajax: {
                url: "http://parkinsonnet.dev/orgs.json",
                dataType: 'json'
            }
        });
    }*/

    if ($('.grid').length) {
        var qsRegex;
        var buttonFilter;

        // init Isotope
        var $grid = $('.grid').isotope({
            itemSelector: '.grid-item',
            layoutMode: 'fitRows',
            filter: function () {
                var $this = $(this);
                var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
                var buttonResult = buttonFilter ? $this.is(buttonFilter) : true;
                return searchResult && buttonResult;
            }
        });

        $('.filter').on('change', function () {
            buttonFilter = this.value;
            $grid.isotope();
        });

        // use value of search field to filter
        var $quicksearch = $('.quicksearch').keyup(debounce(function () {
            qsRegex = new RegExp($quicksearch.val(), 'gi');
            $grid.isotope();
        }));
    }



// debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
        var timeout;
        threshold = threshold || 100;
        return function debounced() {
            clearTimeout( timeout );
            var args = arguments;
            var _this = this;
            function delayed() {
                fn.apply( _this, args );
            }
            timeout = setTimeout( delayed, threshold );
        };
    }


});
